import { Box } from '@mui/material';
import { useTheme } from '@/styles/use-finance-theme';
import { SurfaceCard } from '../data-display/SurfaceCard.tsx';
import { SectionHeader } from './SectionHeader.tsx';
import type { ActionDescriptor } from '@finance/contracts';

export interface FormSurfaceProps {
  id?: string;
  title?: string;
  description?: string;
  actions?: ActionDescriptor[];
  onAction?: (action: ActionDescriptor) => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export function FormSurface({
  id,
  title,
  description,
  actions,
  onAction,
  children,
  footer,
}: FormSurfaceProps) {
  const theme = useTheme();

  return (
    <SurfaceCard
      id={id}
      surfaceRole="standard"
      padding="comfortable"
      sx={{
        width: '100%',
        maxWidth: theme.financeLayout.form.maxWidth,
        mx: 'auto',
      }}
    >
      <SectionHeader title={title} description={description} actions={actions} onAction={onAction} />
      <Box component="div" sx={{ display: 'flex', flexDirection: 'column', gap: theme.financeLayout.form.fieldGap }}>
        {children}
      </Box>
      {footer && <Box sx={{ mt: theme.financeLayout.form.sectionGap }}>{footer}</Box>}
    </SurfaceCard>
  );
}
